import React from "react";
import { Analytics } from "@/lib/analyticsShim";

export const Textarea = React.forwardRef(function Textarea({ className = "", ...props }, ref) {
  return <textarea ref={ref} className={className} {...props} />;
});
